module.exports = __webpack_public_path__ + "static/media/header-image-mobile.c9e5b4e7.jpg";